import request from '@/utils/request';
import { BASE_API } from '@/utils/consts'
import { func } from 'prop-types';

// 添加模板
export function addCombo(data) {
  return request(`${BASE_API}/combo/create`, {
    method: 'POST',
    data
  });
}

// 编辑模板
export function updateCombo(data) {
  return request(`${BASE_API}/combo/update`, {
    method: 'PUT',
    data
  });
}

// 模板详情
export function getCombo(data) {
  return request(`${BASE_API}/combo/show/${data.id}`)
}

// 查看模板列表
export function quertComboList(data) {
  return request(`${BASE_API}/combo/list`, {
    method: 'POST',
    data
  });
}

// 发布下架商品
export async function lockCombo(data) {  
  return request(`${BASE_API}/combo/enable`, {
    data,
    method: 'PUT'
  });
}

export async function queryCategory(data) {
  return request(`${BASE_API}/category/clinic/list`, {
    method: 'POST',
    data
  });
}

export async function addCategory(data) {
  return request(`${BASE_API}/category/clinic/create`, {
    method: 'POST',
    data
  });
}

export async function getCategory(data) {
  return request(`${BASE_API}/category/show/${data.id}`)
}

export async function updateCategory(data) {
  return request(`${BASE_API}/category/update`, {
    method: 'PUT',
    data
  });
}

export async function deleteCategory(data) {
  return request(`${BASE_API}/category/delete/${data.id}`, {
    method: 'DELETE'
  });
}

//产品分类发布-解除发布
export async function lockCategory(data) {  
  return request(`${BASE_API}/category/lock/${data.categoryId}`, {
    method: 'PUT'
  })
}